import { render, staticRenderFns } from "./Contents.vue?vue&type=template&id=6c9f32c4&"
import script from "./Contents.vue?vue&type=script&lang=js&"
export * from "./Contents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports